export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-confirm]').forEach((el) => {
      el.addEventListener('click', (event) => {
        const message = el.dataset.confirm
        if (!message || !confirm(message)) {
          event.preventDefault()
          event.stopPropagation()
        }
      })
    })
  })
})()
